import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { ButtonModalClose, Modal } from 'platfi-ui-components';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';

import modalEnum from 'enums/modal';
import withModalActions from 'HOC/withModalActions';

class ModalLayout extends PureComponent {
  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
    closeModal: PropTypes.func.isRequired,
    isCloseButtonHidden: PropTypes.bool,
    contentOnTop: PropTypes.bool,
    closeOnLocationChange: PropTypes.bool,
    isModalOpen: PropTypes.func.isRequired,
    location: PropTypes.object,
    modalId: PropTypes.string.isRequired,
    modalState: PropTypes.func.isRequired,
    onClose: PropTypes.func,
  };

  static defaultProps = {
    contentOnTop: true,
    closeOnLocationChange: false,
  };

  getModalId = () => modalEnum[this.props.modalId];

  handleClose = () => {
    const { closeModal, onClose } = this.props;

    closeModal(this.getModalId());
    onClose && onClose();
  };

  handleEscKey = ({ which: key }) => {
    key === 27 && this.handleClose();
  };

  isOpen = () => {
    const { isModalOpen, modalId } = this.props;

    return isModalOpen(modalId);
  };

  componentDidMount() {
    document.addEventListener('keydown', this.handleEscKey, false);
  }

  componentDidUpdate(prevProps) {
    const { closeOnLocationChange, location } = this.props;

    if (closeOnLocationChange && prevProps.location.pathname !== location.pathname) {
      this.handleClose();
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleEscKey, false);
  }

  renderCloseButton = () => {
    if (this.props.isCloseButtonHidden) {
      return null;
    }

    return (
      <ButtonModalClose
        className="o-modal__fade o-modal__close"
        handleClose={this.handleClose}
        key={`modal-close-button-${this.getModalId()}`}
      />
    );
  };

  render() {
    // eslint-disable-next-line no-unused-vars
    const { children, modalId, ...rest } = this.props;

    return (
      <Modal closeButton={this.renderCloseButton()} contentOnTop {...rest} isOpen={this.isOpen()}>
        {typeof children === 'function' ? children(this.handleClose, this.isOpen) : children}
      </Modal>
    );
  }
}

export default compose(withModalActions, withRouter)(ModalLayout);
